import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArConnectApiKeyExpiryNotifyKeyManagersProps extends BaseTemplateProps {
  apiKeyName: string
  expiryDate: string
}

export const ArConnectApiKeyExpiryNotifyKeyManagers: TemplateDefinition<ArConnectApiKeyExpiryNotifyKeyManagersProps> =
  {
    renderParams: (props: ArConnectApiKeyExpiryNotifyKeyManagersProps) => ({
      messageKey: 'notificationsDomain.templates.arConnectApiKeyExpiryNotifyKeyManagers',
      values: {
        apiKeyName: props.apiKeyName,
        expiryDate: props.expiryDate,
      },
    }),
  }
